const COMPANIES = {
  AEROLINEAS_ARGENTINAS: 'Aerolíneas Argentinas',
  OPTAR: 'Optar',
  JETPAQ: 'Jetpaq'
}

export default COMPANIES
